import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreImage } from '@types';

const useGetImage = () => {
    const data = useStaticQuery(graphql`
        query AllImage {
            allPatstoreImage {
            edges {
                node {
                        id
                        objectId
                        localFile {
                            absolutePath
                            url
                            publicURL
                            childImageSharp {
                                gatsbyImageData(
                                    width: 1920
                                    placeholder: BLURRED
                                    formats: [WEBP]
                                )
                            }
                        }
                    }
            }
            }
        }
        `);


    const allImage: PatstoreImage[] =
        data.allPatstoreImage.edges.map(
            (edge: { node: PatstoreImage }) => edge.node
        ) || [];

    const findImage: (id: string) => PatstoreImage | undefined = (id: string) => {
        const result = allImage.find((item: PatstoreImage) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findImage,
        images: allImage,
    };
}; 

export default useGetImage;
